export enum EKeys {
    esc = "Esc",
    escape = "Escape",
    enter = "Enter"
}